module.exports = __webpack_public_path__ + "img/program-photo.2f650c0b.jpg";